export default value => {
  if (value === null || value === undefined) return

  return value.toFixed(4).toString().match(/^\d+(?:\.\d{0,4})?/)[0]
}
